
<template lang="pug">
  div(style="")
    slot
    el-form(ref='form' :rules="rules" label-position="top" :model='form')
      // el-form-item(label='工號' prop="id" required)
        el-input(v-model='form.id' disabled)
      el-form-item(label='手機號碼：' prop="userTel" )
        el-input(v-model='form.userTel' type="tel" maxlength="10" placeholder="" disabled)
      el-form-item(label='手機簡訊碼：' prop="code" )
        el-input(v-model='form.code' placeholder="")
      el-col(style="text-align: center;")
        div(v-show="countdown_show") {{ time }}秒後可再次寄送
        el-button(type="primary" @click="sendCode" :disabled="button_disable") 重新寄送

     
      .cart__footer
        el-col(style="text-align: center;")
          el-button(type="primary" @click="submit") 立即驗證
</template>
<script>
import { Loading } from 'element-ui'
import { sendVerificationCode, codeCheck, join } from '@/api/user'
import Cookies from 'js-cookie'

export default {
  name: 'JoinVerification',
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      form: this.data,
      countdown_show: true,
      time: 60,
      button_disable: true,
      rules: {
        userName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        code: [{ required: true, message: '請輸入簡訊驗證碼', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.sendCode();
    // this.countdown_run()
  },
  methods: {
    countdown () {
      console.log("進入", this.time)
      this.time--;
      if(this.time !== 0){
        setTimeout(this.countdown, 1000);
      }else{
        this.button_disable= false
        this.countdown_show= false
      }
    },
    countdown_run () {
      this.time = 60;
      this.button_disable = true;
      this.countdown_show = true;
      this.countdown()
    },
    submit () {
      console.log(this.form)
      // 一般預約驗證
      this.$refs['form'].validate(valid => {
        if (!valid) return false
        // this.$emit('setData', this.form)
        // this.$router.push({ name: 'JoinVerification' })

        const params = {
          userTel: this.form.userTel,
          code: this.form.code
        }
        codeCheck(params).then(res=>{
          if (res.data.status === 1) {
            this.$alert("驗證碼錯誤", {confirmButtonText: '確認'})
            return false
          }
          join(this.form).then(__res=>{
            if (__res.data.status === 1) {
              this.$alert("已經註冊過會員", {confirmButtonText: '確認'})
              return false
            }
            
            Cookies.set("phone", this.form.userTel, { expires: 365 })
            if(this.form.go_to_line) {
              this.$alert("驗證成功，歡迎加入易立洗會員，即將前往line進行通知綁定", {confirmButtonText: '確認',callback: action => {
                // this.$router.push({ name: 'entry' })
                window.open("https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1655423076&redirect_uri=https%3A%2F%2Fserver.ezwash.com.tw%2Fline%2Flogin%2Fcallback&state=1234511111678abcde&scope=profile%20openid&nonce=109876xyz&bot_prompt=aggressive");
              }})
            }else{
              this.$alert("驗證成功，歡迎加入易立洗會員，您可以立即預約洗衣服務。", {confirmButtonText: '確認'})
            }
            
            this.$router.replace({ name: 'info' })
            this.$router.replace({path:decodeURIComponent(url)});
          })
        })
      })
    },
    sendCode () {
      let __loading = Loading.service({text: '簡訊發送中，請稍候...'})
      const params = {
        userTel: this.form.userTel
      }
      sendVerificationCode(params).then((res)=>{
        console.log(res.data)
        __loading.close();
        if(res.data.status === 3){
          this.$alert("該手機號碼，今日發送已經到達上限3次，請明日再試", {confirmButtonText: '確認'})
          return false
        }
        else if (res.data.status !== 0) {
          this.$alert("發送失敗，請稍後再試", {confirmButtonText: '確認'})
          return false
        }
        this.$alert("發送成功，請查看簡訊驗證碼。", {confirmButtonText: '確認'})
        this.countdown_run ()
      })
    }
  },
}
</script>
